module.exports = __webpack_public_path__ + "img/alpha_black.29f1fe33.png";